import * as React from 'react'

import { ChevronDownIcon } from 'lucide-react'
import { observer } from 'mobx-react'

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '~/client/src/shared/components/shadcn-ui/dropdown-menu'
import {
  getOperatorDisplayText,
  IsNotOperator,
  LogicalOperator,
} from '~/client/src/shared/models/LogicOperation'
import { cn } from '~/client/src/shared/utils/cn'

// localization: translated

interface IProps {
  selectedOperator: LogicalOperator
  logicOperatorsList?: LogicalOperator[]
  isSelectable?: boolean

  onChange?: (newOperator: IsNotOperator) => void
}

const OPERATOR_CLASS_NAME =
  'tw:inline-flex tw:h-8 tw:shrink-0 tw:items-center tw:gap-1 tw:rounded-md tw:border tw:border-input tw:bg-transparent tw:px-2 tw:font-mono tw:text-app-mono tw:whitespace-nowrap tw:text-foreground'

@observer
export default class CategoryLogicalOperator extends React.Component<IProps> {
  public render() {
    const { selectedOperator, isSelectable, logicOperatorsList } = this.props

    if (!selectedOperator) {
      return null
    }

    const operatorText = getOperatorDisplayText(selectedOperator)

    if (!isSelectable || !logicOperatorsList?.length) {
      return <span className={OPERATOR_CLASS_NAME}>{operatorText}</span>
    }

    return (
      <DropdownMenu>
        <DropdownMenuTrigger
          className={cn(OPERATOR_CLASS_NAME, 'tw:cursor-pointer')}
        >
          {operatorText}
          <ChevronDownIcon className="tw:size-4 tw:text-muted-foreground" />
        </DropdownMenuTrigger>
        <DropdownMenuContent side="bottom" align="center" className="tw:w-auto">
          <DropdownMenuRadioGroup
            value={selectedOperator}
            onValueChange={this.handleValueChange}
          >
            {logicOperatorsList.map(operator => (
              <DropdownMenuRadioItem
                key={operator}
                value={operator}
                className="tw:font-mono"
              >
                {getOperatorDisplayText(operator)}
              </DropdownMenuRadioItem>
            ))}
          </DropdownMenuRadioGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    )
  }

  private handleValueChange = (operator: IsNotOperator): void => {
    if (operator !== this.props.selectedOperator) {
      this.props.onChange?.(operator)
    }
  }
}
